import { baseApi } from "./baseApi";

export const userApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllStaffForMessage: builder.query<any, { search?: string }>({
      query: ({ search = "" }) => ({
        url: `/employees/all-employees?search=${search}`,
        method: "GET",
      }),
      providesTags: ["staff"],
    }),

    getUserConversations: builder.query<any, string | number>({
      query: (id) => ({
        url: `/chats/conversations/${id}`,
        method: "GET",
      }),
      providesTags: ["messages"],
      transformResponse: (response: any) => response,
    }),

    getSingleUserConversation: builder.query<
      any,
      {
        sender_id: string | number;
        receiver_id: string | number;
        sender_type: string;
        receiver_type: string;
        search?: string;
      }
    >({
      query: ({
        sender_id,
        receiver_id,
        sender_type,
        receiver_type,
        search,
      }) => ({
        url: `/chats/conversation/${sender_id}/${receiver_id}`,
        method: "GET",
        params: {
          sender_type,
          receiver_type,
          ...(search ? { search } : {}),
        },
      }),
      transformResponse: (response: any) => response,
      providesTags: (result) => (result ? ["messages"] : []),
    }),

    sendMessage: builder.mutation<any, FormData>({
      query: (formData) => ({
        url: "/chats/send",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["messages"],
    }),

    // ✅ Get my messages (read / unread / new)
    getMyMessages: builder.query<
      any,
      {
        status?: "read" | "unread" | "new" | "all";
        user_type?: "client" | "staff";
        search?: string;
        page?: number;
      }
    >({
      query: ({ status, user_type = "client", search }) => ({
        url: "/chats/my-messages",
        method: "GET",
        params: {
          user_type,
          ...(status ? { status } : {}),
          ...(search ? { search } : {}),
        },
      }),
      providesTags: ["messages"],
      transformResponse: (response: any) => response,
    }),
    markAllAsRead: builder.mutation<any, { receiver_id: string | number }>({
      query: (body) => ({
        url: "/chats/mark-all-as-read",
        method: "POST",
        body,
      }),
      invalidatesTags: ["messages"], // refresh unread counts & lists
    }),
  }),
});

export const {
  useGetAllStaffForMessageQuery,
  useGetUserConversationsQuery,
  useSendMessageMutation,
  useGetSingleUserConversationQuery,
  useGetMyMessagesQuery,
  useMarkAllAsReadMutation,
} = userApi;
